import type { HotelPolicyQuery, LangCode } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";
import {
	FeatureIslandContainer,
	FeatureIslandHeader,
	FeatureIslandMainWithCategory,
} from "@/components/features/_layouts";

import { useInitialized } from "./model/usecase";
import { HotelPolicyEditPageHeaderUpdateButton } from "./ui/components/header/update-button/update-button";
import { HotelPolicyDefaultEditForm } from "./ui/components/main/question/root";
import { AccommodationHotelPolicyFormModelContext } from "./ui/context";
import { hotelPolicyCategoriesAndManagerStore } from "./ui/store/categories";

type Props = {
	hotelID: string;
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;
	serverModel: HotelPolicyQuery;
};

export const HotelPolicyEditDefaultPresenter = ({
	hotelID,
	activeLangCode,
	navigator,
	serverModel,
}: Props) => {
	const { viewModel, onUpdate, onSetViewModel, queryData, testEmailSender } = useInitialized({
		hotelID,
		serverModel,
	});

	useTransitionBlock(viewModel.isDirty);

	return (
		<AccommodationHotelPolicyFormModelContext.Provider
			value={{
				viewModel,
				onUpdate,
				onSetViewModel,
				queryData,
				testEmailSender,
				hotelID,
			}}
		>
			<FeatureIslandContainer>
				<FeatureIslandHeader
					title="ホテルポリシー設定"
					activeLangCode={activeLangCode}
					navigator={navigator}
					rightChildren={<HotelPolicyEditPageHeaderUpdateButton />}
				/>
				<FeatureIslandMainWithCategory
					categoryManagerStore={hotelPolicyCategoriesAndManagerStore.categoryManagerStore}
				>
					<HotelPolicyDefaultEditForm
						hotelPolicyCategoriesAndManagerStore={hotelPolicyCategoriesAndManagerStore}
					/>
				</FeatureIslandMainWithCategory>
			</FeatureIslandContainer>
		</AccommodationHotelPolicyFormModelContext.Provider>
	);
};

HotelPolicyEditDefaultPresenter.displayName = "HotelPolicyEditDefaultPresenter";
